import { render, staticRenderFns } from "./ArticleBasicInfoForm.vue?vue&type=template&id=2c65cdcb"
import script from "./ArticleBasicInfoForm.vue?vue&type=script&lang=ts"
export * from "./ArticleBasicInfoForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports